import { useState, useEffect, useRef } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { getGradeOptions, redirectToPages, resultAlert } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/homework-sources/HomeworkSourcesAction";
import { 
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { HomeworkSourceEditForm } from "./HomeworkSourceEditForm";

export function HomeworkSourceEdit({
  history,
  match: {
    params: { id }
  }
}) {
  const [title, setTitle] = useState("");
  const [gradeOptions, setGradeOptions] = useState([]);
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, courses, homeworkSource } = useSelector(
    (state) => ({
      actionsLoading: state.homeworkSources.actionsLoading,
      isSuccess: state.homeworkSources.isSuccess,
      type: state.homeworkSources.type,
      courses: state.homeworkSources.courses,
      homeworkSource: state.homeworkSources.homeworkSource
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getHomeworkSource(id));
    return () => dispatch(actions.cleanHomeworkSourcesState());
  }, [id, dispatch]);
  
  useEffect(() => {
    let _title = "Ödev Kaynağı";
    let action = id ? "Düzenle" : "Ekle";
    _title += " " + action;
    setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (homeworkSource && homeworkSource.gradeLevel) setGradeOptions(getGradeOptions(homeworkSource.gradeLevel));
  }, [homeworkSource]);
  
  /** Belli Bir Sınıfa Ait Ders Listesini Elde Eder */
  const getGradeCourses = (grade) => {
    if (grade) dispatch(actions.getGradeCourses(grade));
    else dispatch(actions.cleanCourses());
  };

  /** Belli Bir Ödev Kaynağını Kaydeder */
  const saveHomeworkSource = (values) => {
    dispatch(actions.saveHomeworkSource(values)).then((result) => onResult(result));
  };
  
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push(`/odev-kaynaklari`), 2500);
  };

  const btnRef = useRef();  
  const saveHomeworkSourceClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title} />
      <CardBody>
        <div className="mt-5">          
          <HomeworkSourceEditForm
            courses={courses}
            gradeOptions={gradeOptions}
            homeworkSource={homeworkSource}
            btnRef={btnRef}
            getGradeCourses={getGradeCourses}
            setGradeOptions={setGradeOptions}
            saveHomeworkSource={saveHomeworkSource}
          />
        </div>
      </CardBody>
      <CardFooter>
        <div className="offset-sm-2">          
          <button
            type="submit"
            className="btn btn-primary"
            onClick={saveHomeworkSourceClick}
          >
            Kaydet
          </button>          
        </div>
      </CardFooter>
    </Card>
  );
}